var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.d57af98c4ff23c7deed537be67386870.svg#bb';
                    var viewUrl = 'sprites.d57af98c4ff23c7deed537be67386870.svg#view-bb';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 57 37',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };